import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/subscriptions/subscription-item-quantity-event/:quantityEventId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    quantityEventId: string;
}

const mutationFn = ({ quantityEventId }: DTO): Promise<void> =>
    axios.delete(formatResourcePath(RESOURCE, { quantityEventId }));

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteSubscriptionItemQuantityEvent };
